import React from 'react';
import { useParams } from 'react-router-dom';
// import SCurveContainer from '../containers/SCurveContainer';
import SCurveContainer from '../containers/SCurveContainer';

export default function SCurvePage() {
    const { projectId } = useParams<{ projectId: string }>();

    if (!projectId?.trim()) {
        return <div className="p-6 text-sm text-rose-700">잘못된 프로젝트 ID 입니다.</div>;
    }

    return (
        <div className="w-full //p-6 space-y-4">
            <div className="flex items-end justify-between mb-2">
                <h1 className="text-lg font-semibold">S-Curve Analysis</h1>
            </div>
            {/* <SCurveContainer projectId={projectId} /> */}
            <SCurveContainer projectId={projectId} />
        </div>
    );
}
